import KendoFlatColorPickerMixin from './KendoFlatColorPickerMixin'

export default {
    name: 'kendo-flatcolorpicker',
    mixins: [ KendoFlatColorPickerMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoFlatColorPicker/index.js